export default "__VITE_ASSET__92c8356f__"